import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { checkIsResponseError, getEnv } from '@/common/utils';
import { httpClient } from '@/core/services/http-client';
import { RedeemVoucherParams, RedeemVoucherResponse, RedeemVoucherResponseEntity, RedeemVoucherResponseStatus } from '../models/voucher';

const config = getEnv();

const VOUCHER_REDEMPTIONS_ENDPOINT = `${config.REACT_APP_API_URL}/entitlement-api/v1/voucherRedemptions`;

export const redeemVoucher = (params: RedeemVoucherParams): Observable<RedeemVoucherResponseEntity> =>
  httpClient()
    .authorized.post<RedeemVoucherResponse>(VOUCHER_REDEMPTIONS_ENDPOINT, params)
    .pipe(
      map(({ data, status }) => {
        if (status === 200 || status === 201) {
          return {
            data,
            status: RedeemVoucherResponseStatus.SUCCESS,
          };
        }

        throw undefined;
      }),
      catchError((e) => {
        const data = e?.response?.data;
        if (checkIsResponseError(data)) {
          if (data.code === 'UA-VR-101') {
            return of({
              data,
              status: RedeemVoucherResponseStatus.NOT_RECOGNISED,
            });
          }

          if (data.code === 'UA-VR-102') {
            return of({
              data,
              status: RedeemVoucherResponseStatus.HAS_ALREADY_BEEN_REDEEMED,
            });
          }
        }
        return of({
          data,
          status: RedeemVoucherResponseStatus.NOT_RECOGNISED,
        });
      })
    );
